exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "* {\n  margin: 0;\n  padding: 0;\n}\ninput, button {\n  outline: none;\n}\n.printer-setting {\n  min-width: 800px;\n  max-width: 1080px;\n}\n", ""]);
